window.HelloworkCookieConsentCustomConfig = {
    noticeIntroductionText: "Nous utilisons des cookies pour vous suggérer les offres d’emploi les plus adaptées à votre recherche.",
    noticeModal: true, primaryBtnBackgroundColor: "#63c7e2",
    privacyPolicyUrl: "/infos-legales.html",
    termsOfServiceUrl: "/infos-legales.html"
};

//Cookie Consent: Initialization
document.addEventListener("DOMContentLoaded", function () {
    window.helloworkCookieConsent = new HelloworkCookieConsent();
});